<template lang="pug">
    div.box.linkbox
        router-link.link(to='/')
            i.icon.icon-logo
        router-link.link(to='/' :class="$route.path == '/' && 'on'")
            i.icon.icon-home
            span 今日行情

        router-link.link(to='/stock' :class="$route.path == '/stock' && 'on'")
            i.icon.icon-stock
            span 我的股票

        router-link.link(to='/aoiindex' :class="$route.path == '/aoiindex' && 'on'")
            i.icon.icon-bag
            span 我的地盘

        router-link.link(to='/order' :class="$route.path == '/order' && 'on'")
            i.icon.icon-card
            span 订单中心

        router-link.link(to='/invatation' :class="$route.path == '/invatation' && 'on'")
            i.icon.icon-setting
            span 用户配置

        a.link(href="/faq.pug")
            i.icon.icon-question
            span 常见问题

</template>

<script>
export default {
    name: 'Menu',
    data() {
        return {};
    },
};
</script>

<style lang="stylus" scoped>
.menu
    display flex
    flex-direction column
.linkbox
    position relative
    z-index 5
    width 90px
    transition all .4s
    padding 0
    a
        padding 30px 0 30px 22px
        font-size 14px
        white-space nowrap
        transition all .2s
        &:hover
            background rgba(0,0,0,.3)
            color rgba(255,255,255,.6)

            .icon-home
                background-image url('../imgs/icon-today-on.png')

            .icon-bag
                background-image url('../imgs/icon-position-on.png')

            .icon-card
                background-image url('../imgs/icon-card-on.png')

            .icon-stock
                background-image url('../imgs/icon-stock-on.png')

            .icon-setting
                background-image url('../imgs/icon-config-on.png')

            .icon-question
                background-image url('../imgs/icon-question-on.png')

        &:first-of-type
            i
                margin-left 0

    i
        font-size 36px
        margin 0 22px 0 6px
        color #767a8c
        flex-shrink 0
    span
        opacity 0
        flex-shrink 0
        transition all .2s

    &:hover
        width 160px
        box-shadow 2px 2px 3px 3px rgba(0,0,0,0.5)
        span
            opacity 1
.link
    display flex
    align-items center
    justify-content left
</style>
